<script setup lang="ts">
import Icon from '@components/Icon.vue';
import Button from '@components/Button.vue';
import { computed } from 'vue';
import type { Attachment } from '@global-types/attachment.ts';
import IconImageFill from '@icons/ph_image-fill.svg';
import IconFileFill from '@icons/ph_file-fill.svg';
import IconX from '@icons/ph_x.svg';
import Typography from '@components/Typography.vue';
import { PREVIEWABLE_MIMETYPES } from '@enums/mimeTypes.ts';

const { file, enableRemove = true } = defineProps<{
  file: Attachment,
  enableRemove?: boolean,
}>();

const isFileAnImage = computed<boolean>(() => PREVIEWABLE_MIMETYPES.includes(file.mimetype));

const emit = defineEmits<{(e: 'remove'): void;}>();
</script>

<template>
  <div
    :class="[
      'attachment',
      'rounded-lg border border-solid border-gray',
      'bg-white',
      'h-10 w-fit',
      'p-2',
      'flex items-center gap-x-2',
      'hover:bg-gray-lighter',
    ]"
  >
    <Icon
      :svg="isFileAnImage ? IconImageFill : IconFileFill"
      width="24"
      height="24"
    />

    <Typography variant="body-small-bold">
      {{ file.name }}
    </Typography>

    <Button
      v-if="enableRemove"
      variant="invisible"
      :class="[
        '!m-0',
        '!border-0',
        '!h-6 !w-6',
        '!p-0',
        'group hover:!bg-transparent'
      ]"
      @click="emit('remove')"
    >
      <Icon
        :svg="IconX"
        class="group-hover:text-black"
        width="24"
        height="24"
        fill="current"
      />
    </Button>
  </div>
</template>
